export const UNASSIGNED_VALUE = 'UNASSIGNED';
export const UNASSIGNED_LABEL = 'Unassigned';
export const UNASSIGNED_OPTION = {
  value: UNASSIGNED_VALUE,
  label: UNASSIGNED_LABEL,
} as const;
